const DIAS_SEMANA = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
const MESES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

export function toIsoDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseIso(iso) {
  return new Date(`${String(iso).slice(0, 10)}T12:00:00`);
}

export function startOfWeek(d) {
  const x = new Date(d);
  x.setDate(x.getDate() - x.getDay());
  return x;
}

export function addDaysDate(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function getMonthGridCells(year, month) {
  const first = new Date(year, month - 1, 1);
  const start = startOfWeek(first);
  const cells = [];
  const cursor = new Date(start);
  for (let i = 0; i < 42; i++) {
    cells.push({
      iso: toIsoDate(cursor),
      day: cursor.getDate(),
      inMonth: cursor.getMonth() === month - 1,
      date: new Date(cursor)
    });
    cursor.setDate(cursor.getDate() + 1);
  }
  return cells;
}

export function getWeekDays(anchor) {
  const start = startOfWeek(anchor);
  return Array.from({ length: 7 }, (_, i) => {
    const d = addDaysDate(start, i);
    return { iso: toIsoDate(d), date: d, label: DIAS_SEMANA[d.getDay()] };
  });
}

export function getFetchRange(view, anchor) {
  const y = anchor.getFullYear();
  const m = anchor.getMonth() + 1;

  if (view === 'day') {
    const iso = toIsoDate(anchor);
    return { dataInicio: iso, dataFim: iso, label: anchor.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) };
  }
  if (view === 'week') {
    const days = getWeekDays(anchor);
    return {
      dataInicio: days[0].iso,
      dataFim: days[6].iso,
      label: `${parseIso(days[0].iso).toLocaleDateString('pt-BR')} — ${parseIso(days[6].iso).toLocaleDateString('pt-BR')}`
    };
  }
  if (view === 'year') {
    return {
      dataInicio: `${y}-01-01`,
      dataFim: `${y}-12-31`,
      label: String(y)
    };
  }
  const cells = getMonthGridCells(y, m);
  return {
    dataInicio: cells[0].iso,
    dataFim: cells[cells.length - 1].iso,
    mes: m,
    ano: y,
    label: `${MESES[m - 1]} ${y}`
  };
}

export function navigateAnchor(view, anchor, direction) {
  const d = new Date(anchor);
  const delta = direction === 'next' ? 1 : -1;
  if (view === 'day') d.setDate(d.getDate() + delta);
  else if (view === 'week') d.setDate(d.getDate() + 7 * delta);
  else if (view === 'month') d.setMonth(d.getMonth() + delta);
  else if (view === 'year') d.setFullYear(d.getFullYear() + delta);
  return d;
}

export function enumerateDates(dataInicio, dataFim) {
  const ini = String(dataInicio || '').slice(0, 10);
  const fim = String(dataFim || ini).slice(0, 10);
  const start = parseIso(ini);
  const end = parseIso(fim < ini ? ini : fim);
  const out = [];
  const d = new Date(start);
  while (d <= end) {
    out.push(toIsoDate(d));
    d.setDate(d.getDate() + 1);
  }
  return out;
}

export { DIAS_SEMANA, MESES };
